import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type Result = ModelHookResult<{
	isSunriseActionPanelEnabled: boolean;
	isSunriseHeadingEnabled: boolean;
	isSunrisePetitionHeaderEnabled: boolean;
	isSunriseHeaderExperimentEnabled: 'control' | 'fake_control' | 'variant_a' | 'variant_b';
	sunriseActionPanelExperimentVariation: string;
}>;

export const useIsFullSunriseEnabled = (): Result => {
	const {
		data: {
			featureConfigs: { petitionPageFullSunrise },
		},
	} = usePetitionDetailsPageData();

	const {
		data: { fullSunrisePetitionHeaderExperiment, fullSunriseActionPanelExperimentVariation },
	} = usePetitionDetailsPageUserData();

	/* We will use the FC to determine if full sunrise is enabled for a given module.
	 * In case a module is being experimented on, we will only fetch the experiment, no need for the FC since
	 * the experiment will use the FC under the hood.
	 */
	const { actionPanel, petitionHeading, petitionHeader } = petitionPageFullSunrise;

	return {
		data: {
			isSunriseActionPanelEnabled: !!actionPanel?.enabled,
			isSunriseHeadingEnabled: !!petitionHeading?.enabled,
			isSunrisePetitionHeaderEnabled: !!petitionHeader?.enabled,
			isSunriseHeaderExperimentEnabled: fullSunrisePetitionHeaderExperiment,
			sunriseActionPanelExperimentVariation: fullSunriseActionPanelExperimentVariation,
		},
	};
};
